module.exports = __webpack_public_path__ + "img/页面图片修改2-1.88efa282.png";